import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { clsx } from 'clsx';

import { Table, Pagination } from '@treezor/design-system';

import {
  useAllBeneficiariesTableData,
  IUseAllBeneficiariesTableDataProps,
} from '@/features/beneficiaries/hooks/AllBeneficiaries/useAllBeneficiariesTableData';
import { BENEF_ITEM_PER_PAGE } from '@/features/beneficiaries/constants';
import { AllBeneficiariesFilters } from '@/features/beneficiaries/components/AllBeneficiaries/AllBeneficiariesFilters';
import { EmptyState } from '@/ui-kit/templates/EmptyState/EmptyState';

export function AllBeneficiariesTable(props: IUseAllBeneficiariesTableDataProps) {
  const { t } = useTranslation();

  const state = useLocation().state || undefined;

  const { fields, rows, headers, currentPage, totalRows, onPageChange, clearFilters } = useAllBeneficiariesTableData({
    ...props,
    data: {
      ...props.data,
      filter: {
        ...props.data.filter,
        ...state,
      },
    },
  });

  return (
    <div className="flex flex-col overflow-auto">
      <AllBeneficiariesFilters fields={fields} />
      <div className="flex flex-col overflow-auto gap-4">
        <Table
          columns={headers}
          rows={rows}
          hasStickyHeader
          className={clsx('bg-primary', props?.className)}
          emptyComponent={
            <EmptyState
              title={t('components.molecules.table.noRecord')}
              icon="search_v1"
              size="m"
              className="p-6"
              action={t('components.molecules.table.tryToResetFilters')}
              onClick={() => clearFilters()}
              buttonIcon={null}
              testId="btn-beneficiaries-clear-filter"
            />
          }
        />

        {totalRows > BENEF_ITEM_PER_PAGE && (
          <Pagination
            isRangeVisible
            itemCount={totalRows}
            activePage={currentPage - 1}
            onPageChange={(item) => onPageChange(item.selected + 1)}
            itemPerPage={BENEF_ITEM_PER_PAGE}
            isFirstButtonVisible
            isLastButtonVisible
            className="flex justify-end"
          />
        )}
      </div>
    </div>
  );
}
